import React from "react";
import Check from '@mui/icons-material/Check';

export function CheckBoxIcon() {
    return (
        <Check />
    )
}